import Marquee from "react-fast-marquee";
import { LOGOS } from "@/data/content";

export const TrustedBy = () => {
  return (
    <section
      data-testid="trustedby-section"
      className="px-0 py-20 md:py-28 bg-white border-b border-hairline overflow-hidden"
    >
      <div className="px-6 md:px-12">
        <div className="mx-auto max-w-[1400px]">
          <div className="flex flex-col md:flex-row md:items-center gap-6 mb-12 md:mb-16">
            <span className="font-mono text-xs uppercase tracking-[0.25em] text-forest whitespace-nowrap">
              Trusted by
            </span>
            <span className="hidden md:block h-px flex-1 bg-hairline" />
            <p className="text-ink/55 text-base md:text-lg max-w-md md:text-right">
              From global names to fast-growing challengers — brands that demand measurable growth.
            </p>
          </div>
        </div>
      </div>

      <div className="border-y border-hairline bg-white py-10 md:py-12">
        <Marquee speed={32} gradient gradientColor="#FFFFFF" gradientWidth={120} pauseOnHover>
          {LOGOS.map((logo, i) => (
            <div
              key={logo.src}
              data-testid={`trust-logo-${i}`}
              title={logo.name}
              className="group mx-10 md:mx-16 flex items-center justify-center"
            >
              <img
                src={logo.src}
                alt={logo.name}
                loading="lazy"
                className="max-h-8 md:max-h-10 w-auto object-contain opacity-45 grayscale group-hover:opacity-100 group-hover:grayscale-0 transition-all duration-500"
              />
            </div>
          ))}
        </Marquee>
      </div>
    </section>
  );
};
